import { render, staticRenderFns } from "./AdditionalFieldCard.vue?vue&type=template&id=5a2d7671&scoped=true"
import script from "./AdditionalFieldCard.vue?vue&type=script&lang=js"
export * from "./AdditionalFieldCard.vue?vue&type=script&lang=js"
import style0 from "./AdditionalFieldCard.vue?vue&type=style&index=0&id=5a2d7671&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2d7671",
  null
  
)

export default component.exports